export const UnknownBayNumber = -1
